import { ActionContext } from "vuex";
import {
  Rating,
  RatingList,
  UserLikes
} from "../../../../../domain/entities/rating";
import {
  ContentState,
  getContentProvider,
  getCurrentContent
} from "./content_module";
import Login from "../../../../presentation/components/landingpage/Login.vue";

class RatingState {
  ratingsList: RatingList = new RatingList();
}

const state = new RatingState();
type RatingActionContext = ActionContext<RatingState, ContentState>;

const mutations = {
  SET_RATINGS(state: RatingState, ratings: RatingList) {
    for (let rating of ratings.ratings) {
      state.ratingsList.ratings.push(rating);
    }

    state.ratingsList.haveRatings = ratings.haveRatings;
  },
  SET_CLEAR_RATINGS(state: RatingState) {
    state.ratingsList = new RatingList([], false);
  },

  ADD_RATING(state: RatingState, rating: Rating) {
    state.ratingsList.ratings.unshift(rating);
  },

  PATCH_LIKE_RATING(
    state: RatingState,
    payload: { id: number; userID: number; isLike: boolean }
  ) {
    const patchIndex = state.ratingsList.ratings.findIndex(
      item => item.id === payload.id
    );

    if (payload.isLike) {
      state.ratingsList.ratings[patchIndex].likes.push(
        new UserLikes(payload.userID)
      );
    } else {
      const userIndex = state.ratingsList.ratings[patchIndex].likes.findIndex(
        item => item.userID === payload.userID
      );
      state.ratingsList.ratings[patchIndex].likes.splice(userIndex, 1);
    }
  },

  PATCH_RATING(state: RatingState, id: number) {
    const patchIndex = state.ratingsList.ratings.findIndex(
      item => item.id === id
    );

    state.ratingsList.ratings.splice(patchIndex, 1);
  }
};

const actions = {
  async loadRatings(ctx: RatingActionContext, index?: number) {
    try {
      const provider = getContentProvider(ctx);
      const content = getCurrentContent(ctx);
      const response: RatingList =
        (await provider.getAllRatings(content.id, index)) ?? new RatingList();

      ctx.commit("SET_RATINGS", response);
    } catch (e) {
      console.error("[loadRatings] Error getAllRatings ", e);
      throw e;
    }
  },

  async clearRatings(ctx: RatingActionContext) {
    try {
      ctx.commit("SET_CLEAR_RATINGS");
    } catch (e) {
      console.error("[loadRatings] Error getAllRatings ", e);
      throw e;
    }
  },

  async createRating(ctx: RatingActionContext, rating: Rating) {
    try {
      const provider = getContentProvider(ctx);
      const content = getCurrentContent(ctx);
      const response = await provider.createRating(content.id, rating);
      ctx.commit("ADD_RATING", response);
    } catch (e) {
      console.error("[createRating] Error createRating ", e);
      throw e;
    }
  },

  async likeRating(
    ctx: RatingActionContext,
    payload: { ratingID: number; userID: number }
  ) {
    try {
      const provider = getContentProvider(ctx);
      await provider.likeRating(payload.ratingID);
      ctx.commit("PATCH_LIKE_RATING", {
        id: payload.ratingID,
        userID: payload.userID,
        isLike: true
      });
    } catch (e) {
      console.error("[likeRating] Error likeRating ", e);
      throw e;
    }
  },

  async removeLikeRating(
    ctx: RatingActionContext,
    payload: { ratingID: number; userID: number }
  ) {
    try {
      const provider = getContentProvider(ctx);
      await provider.removeLikeRating(payload.ratingID);
      ctx.commit("PATCH_LIKE_RATING", {
        id: payload.ratingID,
        userID: payload.userID,
        isLike: false
      });
    } catch (e) {
      console.error("[removeLikeRating] Error removeLikeRating ", e);
      throw e;
    }
  },

  async deleteRating(ctx: RatingActionContext, ratingID: number) {
    try {

      const provider = getContentProvider(ctx);
      const content = getCurrentContent(ctx);
      await provider.deleteRating(content.id, ratingID);

      ctx.commit("PATCH_RATING", ratingID);
    } catch (e) {
      console.error("[deleteRating] Error deleteRating ", e);
      throw e;
    }
  }
};

const getters = {
  ratings: (state: RatingState) => state.ratingsList
};

const modules = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
  modules
};
